module.exports = __webpack_public_path__ + "r-v3/img/pen.7d1f2366.svg";